var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_488396",
    "data-name": "Group 488396",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.047,
    height: 18.074,
    viewBox: "0 0 17.047 18.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_180757",
    "data-name": "Path 180757",
    d: "M77.377,112.9q-1.293,0-2.577,0a1.069,1.069,0,0,1-1.206-1.19q-.012-2.453,0-4.905a1.061,1.061,0,0,1,1.2-1.194c.857-.006,1.715,0,2.613,0,.007-.162.019-.3.019-.434,0-1.388,0-2.776,0-4.164,0-1.145.518-1.662,1.654-1.662,2.117,0,4.234,0,6.352,0a.817.817,0,0,1,.653.263c1.421,1.489,2.857,2.964,4.269,4.462a1.091,1.091,0,0,1,.272.68c.017,3.682.013,7.364.011,11.045A1.44,1.44,0,0,1,89,117.42H79.018a1.415,1.415,0,0,1-1.594-1.58c-.008-.941-.006-1.882-.01-2.823A.6.6,0,0,0,77.377,112.9Zm.733,0c0,1,0,1.963,0,2.924,0,.663.234.892.894.892h9.985c.725,0,.949-.222.949-.943q0-5.222,0-10.444v-.413H85.673c-.51,0-.6-.089-.6-.587q0-1.941,0-3.881v-.4H79.031c-.7,0-.92.222-.921.936,0,1.411.009,2.823-.008,4.234,0,.309.078.4.393.4,1.776-.015,3.552-.009,5.327-.006.865,0,1.249.387,1.25,1.247,0,1.482-.03,2.965.011,4.445.029,1.05-.215,1.655-1.62,1.611C81.7,112.861,79.936,112.9,78.11,112.9Zm1.25-.7q2.24,0,4.479,0c.44,0,.531-.093.532-.54q0-2.416,0-4.832c0-.421-.1-.527-.516-.528q-4.532,0-9.065,0c-.392,0-.5.118-.5.511q-.005,2.434,0,4.868c0,.412.113.52.523.52Q77.085,112.2,79.36,112.2ZM85.8,100.329v3.859h3.713Z",
    transform: "translate(-73.588 -99.346)",
    fill: "#8e92a4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180758",
    "data-name": "Path 180758",
    d: "M142.452,222.776v-2.967c.488,0,.955,0,1.421,0a.741.741,0,0,1,.172.036c.625.16.95.805.867,1.725a1.157,1.157,0,0,1-1.086,1.178c-.328.024-.658.018-.987.025C142.723,222.778,142.606,222.776,142.452,222.776Zm.577-.505c.409-.061.84.155,1.127-.263a1.693,1.693,0,0,0-.044-1.479c-.3-.323-.7-.23-1.083-.225Z",
    transform: "translate(-137.591 -211.306)",
    fill: "#8e92a4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180759",
    "data-name": "Path 180759",
    d: "M102.844,219.162c.555.024,1.072.02,1.583.077a.8.8,0,0,1,.695.873.86.86,0,0,1-.768.9c-.291.031-.584.039-.911.06v1.076h-.6Zm.62.52v.834a2.381,2.381,0,0,0,.678-.016.539.539,0,0,0,.33-.369.528.528,0,0,0-.307-.382A2.672,2.672,0,0,0,103.464,219.681Z",
    transform: "translate(-100.779 -210.704)",
    fill: "#8e92a4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180760",
    "data-name": "Path 180760",
    d: "M184.7,219.752h2.009v.469H185.32v.721h.8c.447,0,.447,0,.392.494H185.3v1.244c-.618.1-.619.1-.619-.466q0-1.039,0-2.079C184.681,220.01,184.692,219.885,184.7,219.752Z",
    transform: "translate(-176.838 -211.253)",
    fill: "#8e92a4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.4519b8e56599de49a1f0d040bce9c50b.svg";
export { ForwardRef as ReactComponent };